import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AppearanceShow20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.99996 6.25C7.9289 6.25 6.24996 7.92893 6.24996 10C6.24996 12.0711 7.9289 13.75 9.99996 13.75C12.071 13.75 13.75 12.0711 13.75 10C13.75 7.92893 12.071 6.25 9.99996 6.25ZM7.74996 10C7.74996 8.75736 8.75732 7.75 9.99996 7.75C11.2426 7.75 12.25 8.75736 12.25 10C12.25 11.2426 11.2426 12.25 9.99996 12.25C8.75732 12.25 7.74996 11.2426 7.74996 10Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.395518 9.55177C0.151999 9.82781 0.123028 10.1938 0.386947 10.4504C3.11691 13.1047 5.83095 16.25 9.99996 16.25C13.7538 16.25 16.98 13.3783 19.3508 10.7374C19.9159 10.1079 19.8535 9.87401 19.3508 9.24219C17.0949 6.56803 13.6531 3.75 9.99996 3.75C6.01322 3.75 2.85712 6.76141 0.395518 9.55177ZM17.9921 10C15.9353 7.79588 13.2124 5.25 9.99996 5.25C6.88828 5.25 4.0216 7.84202 2.00781 10C4.0216 12.158 6.88828 14.75 9.99996 14.75C13.2124 14.75 15.9353 12.2041 17.9921 10Z'
      fill='currentColor'
    />
  </Svg>
);

AppearanceShow20.displayName = 'AppearanceShow20';
export default AppearanceShow20;
